import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { AdminHeaderService } from '../services/admin.header.service';
import { StateService, TransitionService as UIRouterTransitionService, Transition } from '@uirouter/angular';

@Component({
    selector: 'admin-header',
    template: require('./admin.header.component.html')
})
export class AdminHeaderComponent implements OnInit, OnDestroy {

    protected currentState: string = 'home.admin';
    protected subText: string;
    private deregisterTransition: any = null;

    constructor(
        private adminHeaderService: AdminHeaderService,
        private stateService: StateService,
        private $transitions: UIRouterTransitionService,
    ) { }
    
    ngOnInit() {
        this.currentState = this.stateService.current.name;
        this.subText = this.adminHeaderService.getTitleForState(this.currentState);

        // Update header when any admin state transition succeeds
        this.deregisterTransition = this.$transitions.onSuccess({ to: 'home.admin.**' }, (transition: Transition) => {
            const to = transition.to();
            if (to) {
                this.currentState = to.name;
                this.subText = this.adminHeaderService.getTitleForState(this.currentState);
            }
        });
    }

    ngOnDestroy() {
        if (this.deregisterTransition) {
            this.deregisterTransition();
            this.deregisterTransition = null;
        }
    }
}